import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useData } from "@pure-ptr/react";
import React, { useContext, useState } from 'react';

import { getClaimStatusSummary } from "../../store/api/summaryDashboard";
import { asDollarsWithZero } from '../../util/format';

import { DashboardFiltersContext, useClaimAnalysisPage, useStyles } from './Dashboard';
import { nonPaginatedSorting } from '../../util';
import WidgetsSortingComponent from './WidgetsSortingComponent';

export const ClaimStatusWidget = () => {
    const classes = useStyles();
    const { dateRange } = useContext(DashboardFiltersContext);
    const [sortConfig, setSortConfig] = useState({ key: 'count', direction: 'desc' });

    const { data, isPending } = useData(async () => {
        const result = await getClaimStatusSummary(dateRange.startdate, dateRange.enddate);
        return result;
    }, [dateRange]);

    const openClaimAnalysis = useClaimAnalysisPage();

    const handleStatusClick = (statusId: number) => {
        openClaimAnalysis({
            filter: [
                {
                    actualFilter: true,
                    equator: "equals",
                    field: "claimStatusId",
                    value: String(statusId)
                }
            ],
            customFilter: [
                {
                    customFilter: true,
                    equator: "greater_than_or_equals_to",
                    field: "remitdate",
                    value: dateRange.startdate,
                    relativeFilter: dateRange.relativeFilter
                },
                {
                    customFilter: true,
                    equator: "less_than_or_equals_to",
                    field: "remitdate",
                    value: dateRange.enddate,
                    relativeFilter: dateRange.relativeFilter
                }
            ],
            significance: false,
        });
    };

    const sortableColumns = [
        { key: 'name', label: 'Status' },
        { key: 'count', label: 'Count' },
        { key: 'totalVarianceAmount', label: 'Total Amount' },
    ];

    const sortedData = React.useMemo(
        () =>
            nonPaginatedSorting(
                [sortConfig],
                [...(data || [])]
            )?.tableData,
        [data, sortConfig]
    );

    return isPending ? (
        <CircularProgress />
    ) : (
        <Table stickyHeader>
            <TableHead>
                <TableRow key='claimStatusHeader'>
                    <WidgetsSortingComponent
                        sortableColumns={sortableColumns}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                    />
                </TableRow>
            </TableHead>
            <TableBody>
                {sortedData?.map((item) => (
                    <TableRow key={item.id}>
                        <TableCell>
                            <Typography
                                onClick={() => handleStatusClick(item.id)}
                                variant="body2"
                                className={classes.link}
                            >
                                {item.name}
                            </Typography>
                        </TableCell>
                        <TableCell>{item.count}</TableCell>
                        <TableCell>{asDollarsWithZero(item.totalVarianceAmount)}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};